import { render, staticRenderFns } from "./suitch-valve.vue?vue&type=template&id=0abf356a&"
import script from "./suitch-valve.vue?vue&type=script&lang=js&"
export * from "./suitch-valve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports